import React from 'react'
import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Button, Col, Row, Divider } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as CompaniaService from 'services/compania.service'

import * as FormGroups from './formGroups'

export const ValidationSchema = Yup.object().shape({
  _idCompaniaReferencia: Yup.string().required(),
  ruc: Yup.string().required(),
  razonSocial: Yup.string().required()
})

const MainForm = () => {
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const formInitialValues = React.useMemo(() => {
    return {
      _idCompaniaReferencia: '',
      ruc: '',
      razonSocial: '',
      direccion: '',
      _idDepartamento: '',
      _idProvincia: '',
      _idDistrito: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      CompaniaService.nuevaCompania(data)
        .then(() => {
          __zariContext.snack('success', 'Compania creada.')
          history.push('/')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, history]
  )

  return (
    <Formik initialValues={formInitialValues} onSubmit={onSubmit} validationSchema={ValidationSchema}>
      {({ errors, touched, values, isSubmitting, setFieldValue, handleSubmit, setValues, handleChange }) => (
        <Form>
          <Row>
            <Col md={6}>
              <FormGroups.RucFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors.ruc}
                iTouched={touched.ruc}
                setFieldValue={setFieldValue}
                vRuc={values.ruc}
              />
              <FormGroups.RazonSocialFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors.razonSocial}
                iTouched={touched.razonSocial}
              />
              <FormGroups.DireccionFormGroup
                iError={errors.direccion}
                iTouched={touched.direccion}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.DepartamentoFormGroup
                values={values}
                setValues={setValues}
                handleChange={handleChange}
                iError={errors._idDepartamento}
                iTouched={touched._idDepartamento}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.ProvinciaFormGroup
                values={values}
                setValues={setValues}
                handleChange={handleChange}
                idDepartamento={values._idDepartamento}
                iError={errors._idProvincia}
                iTouched={touched._idProvincia}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.DistritoFormGroup
                idProvincia={values._idProvincia}
                iError={errors._idDistrito}
                iTouched={touched._idDistrito}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.CompaniaReferenciaFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors._idCompaniaReferencia}
                iTouched={touched._idCompaniaReferencia}
              />
              <Divider />
              <Row>
                <Col md={12} className='text-right'>
                  <Button onClick={handleSubmit}>Guardar</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(MainForm)
